import React from "react";
import PropTypes from "prop-types";

function getProgramStatus(startDate, endDate) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const start = new Date(`${startDate}T00:00:00`);
  const end = new Date(`${endDate}T23:59:59`);

  if (today < start) {
    return "Upcoming";
  }

  if (today <= end) {
    return "In Progress";
  }

  return "Completed";
}

function getStatusClass(status) {
  switch (status.toLowerCase()) {
    case "in progress":
      return "text-bg-success";

    case "upcoming":
      return "text-bg-primary";

    case "completed":
      return "text-bg-secondary";

    default:
      return "text-bg-secondary";
  }
}

function FlagFootballProgramCard({ program }) {
  const {
    title="Registration Information",
    description="",
    startDate="2026-09-21",
    endDate="2026-09-26",
    dates="September 21st-26th",
    playoffs="2026-12-11",
    ageGroup="K-8th",
    price="Regular - $175, Late - $195",
    location="ADS Sports Complex",
    locationUrl="10251 E Loop 1604 N, Converse, TX 78109",
    registrationUrl = "https://app.teampass.com/product/227497?a=1&sid=9813_A847EA42EFC2059D8EC7AA4A6E646356",
  } = program;

  const status = getProgramStatus(startDate, endDate);

  return (
    <article className="basketball-program-card">
      <div className="basketball-program-card__header">
        <h3 className="basketball-program-card__title futuraPTBold">
          {title}
        </h3>

        <span
          className={`badge rounded-pill ${getStatusClass(
            status
          )} basketball-program-card__status`}
        >
          {status}
        </span>
      </div>

      {description && (
        <p className="basketball-program-card__description futuraPTBook">
          {description}
        </p>
      )}

      <div className="row gy-4">
        <div className="col-12 col-md-6">
          <span className="basketball-program-card__label">
            Age Group:
          </span>

          <span className="basketball-program-card__value">
            {ageGroup}
          </span>
        </div>

        <div className="col-12 col-md-6">
          <span className="basketball-program-card__label">
            Season Dates:
          </span>

          <span className="basketball-program-card__value">
            {dates}
          </span>
        </div>

        {playoffs && (
          <div className="col-12 col-md-6">
            <span className="basketball-program-card__label">
              Playoffs:
            </span>

            <span className="basketball-program-card__value">
              {playoffs}
            </span>
          </div>
        )}

        <div className="col-12 col-md-6">
          <span className="basketball-program-card__label">
            Registration Fee:
          </span>

          <span className="basketball-program-card__value">
            {price}
          </span>
        </div>

        <div className="col-12">
          <span className="basketball-program-card__label">
            Location:
          </span>

          <span className="basketball-program-card__value">
            <a
              href={locationUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              {location}
            </a>
          </span>
        </div>

        {registrationUrl && (
          <div className="col-12">
            {/* <a
              href={registrationUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="basketball-program-card__register-button"
            >
              CLICK HERE TO REGISTER!
            </a> */}
          </div>
        )}
      </div>
    </article>
  );
}

FlagFootballProgramCard.propTypes = {
  program: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    startDate: PropTypes.string.isRequired,
    endDate: PropTypes.string.isRequired,
    dates: PropTypes.string.isRequired,
    playoffs: PropTypes.string,
    ageGroup: PropTypes.string.isRequired,
    price: PropTypes.string.isRequired,
    location: PropTypes.string.isRequired,
    locationUrl: PropTypes.string.isRequired,
    registrationUrl: PropTypes.string
  }).isRequired
};

export default FlagFootballProgramCard;